var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-style",attrs:{"id":"app"}},[_c('router-view'),_c('snack-bar'),_c('loading-overlay'),(_vm.loggedInUser)?_c('search-modal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }